import cx from 'classnames'
import React from 'react'
import { useSlate } from 'slate-react'

import { isBlockTypeActive, toggleBlock } from '../util'

export function BlockButton ({ format, onClick, icon, label }) {
  const editor = useSlate()
  const isActive = isBlockTypeActive(editor, format)
  const title = [ label, isActive && '(active)' ].filter(Boolean).join(' ')

  return (
    <button
      type='button'
      className={cx('rounded-sm transition-colors flex flex-row gap-3 w-full disabled:text-[#aaaaaa] disabled:cursor-not-allowed', [
        isActive ? 'text-primary' : 'text-[#9CA3AF]'
      ])}
      onMouseDown={event => {
        event.preventDefault()
        onClick ? onClick() : toggleBlock(editor, format)
      }}
      title={title}
    >
      {typeof icon === 'string'
        ? (
          <i className={`fa fa-${icon} fa-fw`} />
        )
        : icon }
    </button>
  )
}
